import e from"clsx";const a="perxis-auto",t=(...t)=>e(...t).split(" ").map((e=>e.includes("perxis-auto-1_14_29")||e.includes("ant-5_17_0")?e:e.includes(a)?e.replace(a,"perxis-auto-1_14_29"):e.includes("ant")?e.replace("ant","ant-5_17_0"):e)).join(" ");export{t as default};
//# sourceMappingURL=classnames.js.map
